<template>
  <modal
    :show.sync="showDiscountModal"
    modal-classes="modal-dialog-centered modal-lg"
    body-classes
    @close="hideModalFromButtonClose()"
    no-close-on-backdrop
  >
    <template slot="header">
      <h5 class="subtitle" id="modalcolumns">Manage Discounts</h5>
    </template>

    <div class="row align-items-center mt-2 forms">
      <div class="col-6 align-self-center "></div>
      <div class="col-6 text-right align-self-center">
        <!-- este boton agrega una fila dentro  del div con id rows-discounts -->
        <base-button
          type="link"
          class="min-button p-0 mb-0"
          @click="addNewDiscount"
        >
          <i class="flaticon-plus"></i> Add More
        </base-button>
      </div>

      <div class="col-12 mt-2">
        <div
          class="rows-extra"
          id="rows-discounts"
          v-show="localDiscounts.length > 0"
        >
          <div
            class="row"
            v-for="(item, index) in $v.localDiscounts.$each.$iter"
            :key="index"
          >
            <div
              class="col-xl-2 col-lg-2 col-md-3 col-sm-3 col-4 option-transfers mb-3"
            >
              <label for="" class="title-label"
                ><span class="markrequired">*</span>Value</label
              >
              <b-form-radio-group
                id="radio-typediscount"
                v-model="item.type.$model"
                aria-describedby="ariaDescribedby1"
                name="radio-typediscount"
                buttons
                button-variant="group-neutral"
                class="buttons-type"
              >
                <b-form-radio value="percentage" tabindex="15">%</b-form-radio>
                <b-form-radio value="absolute">{{
                  currency.code
                }}</b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-9 col-sm-9 col-8 pr-0 ">
              <WSelect
                v-model="item.description.$model"
                label="Description"
                placeholder=""
                filterable
                clearable
                :error="item.description.$error ? 'Select an Description' : ''"
                markrequired
              >
                <el-option
                  v-for="(item, index) in discountsTypes"
                  :value="item.name"
                  :label="item.name"
                  :key="index"
                ></el-option>
              </WSelect>
            </div>

            <div
              class="col-xl-2 col-lg-2 col-md-5 col-sm-5 col-5 pr-0 align-self-center"
              v-if="item.type.$model === 'percentage'"
            >
              <BaseNumberInput
                v-model.number="item.percent.$model"
                label="Percent"
                placeholder="Percent"
                class="input-append"
                @input="caculateTotal(item)"
                :error="item.percent.$error ? `Enter a Price` : ''"
                markrequired
              >
                <template slot="append">%</template>
              </BaseNumberInput>
            </div>

            <div
              class="col-xl-3 col-lg-3 col-md-5 col-sm-5 col-5 pr-0 align-self-center"
              v-if="item.type.$model === 'percentage'"
            >
              <BaseNumberInput
                v-model.number="item.total.$model"
                label="Total"
                placeholder="Total"
                class="input-append with-prepend"
                :error="item.total.$error ? `Enter a Price` : ''"
                markrequired
              >
                <template slot="prepend">{{ currency.symbol }}</template>
                <template slot="append">{{ currency.code }}</template>
              </BaseNumberInput>
            </div>
            <div
              class="col-xl-3 col-lg-3 col-md-5 col-sm-5 col-5 pr-0 align-self-center"
              v-else
            >
              <BaseNumberInput
                v-model.number="item.total.$model"
                label="Amount"
                placeholder="Amount"
                class="input-append with-prepend"
                :error="item.total.$error ? `Enter a Price` : ''"
                markrequired
              >
                <template slot="prepend">{{ currency.symbol }}</template>
                <template slot="append">{{ currency.code }}</template>
              </BaseNumberInput>
            </div>

            <div
              class="col-xl-1 col-lg-1 col-md-2 col-sm-2 col-2 pr-0 align-self-center"
            >
              <el-tooltip content="Delete" placement="bottom">
                <span class="icon-action mb-4" @click="deleteDiscount(index)">
                  <i class="flaticon-delete text-danger"></i>
                </span>
              </el-tooltip>
            </div>
          </div>
        </div>
        <base-alert
          v-show="localDiscounts.length === 0"
          type="warning"
          class="info-min"
        >
          <i class="flaticon-warning mr-1"></i>
          There are currently no discounts added.
        </base-alert>
      </div>
    </div>

    <template slot="footer">
      <base-button
        type="outline-neutral "
        class="min-button mb-0"
        @click="hideModalFromButtonCancel()"
        >Cancel</base-button
      >

      <base-button
        type="primary"
        class="min-button ml-auto mb-0"
        @click="saveDiscount()"
        >Accept</base-button
      >
    </template>
  </modal>
</template>

<script>
// @ is an alias to /src
import WSelect from "@/components/Select";
import {
  required,
  minValue,
  minLength,
  maxLength,
  requiredIf
} from "vuelidate/lib/validators";
import { withParams } from "vuelidate/lib";
import Swal from "sweetalert2";
import lodash from "lodash";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "ManageDiscounts",
  components: {
    WSelect
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    grossPrice: {
      type: Number,
      required: true
    },
    discounts: {
      type: Array,
      required: true
    },
    currency: {
      code: {
        type: String,
        default: "EUR",
        description: ""
      },
      symbol: {
        type: String,
        default: "€",
        description: ""
      }
    }
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showDiscountModal = current;
      },
      deep: true
    },
    discounts: {
      handler: function(current, old) {
        this.$v.localDiscounts.$reset();
        this.localDiscounts = lodash.cloneDeep(current);
        this.copyLocalDiscounts = lodash.cloneDeep(current);
      },
      deep: true
    },
    grossPrice: {
      handler: function(current, old) {
        this.localGrossPrice = current;
      },
      deep: true
    }
  },
  data() {
    return {
      showDiscountModal: false,
      localGrossPrice: 0,
      localDiscounts: [
        {
          type: "percentage",
          description: "",
          percent: 0,
          total: 0
        }
      ],
      copyLocalDiscounts: [],
      discountsTypes: [{ name: "Discount" }, { name: "Coupon" }],
      limitDiscounts: 2
    };
  },
  async created() {
    this.localDiscounts = lodash.cloneDeep(this.discounts);
    this.copyLocalDiscounts = lodash.cloneDeep(this.discounts);
    this.localGrossPrice = this.grossPrice;
  },
  methods: {
    addNewDiscount() {
      if (this.localDiscounts.length < this.limitDiscounts) {
        this.localDiscounts.push({
          type: "percentage",
          description: "",
          percent: 0,
          total: 0
        });
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "The allowable limit was exceeded",
          icon: "flaticon-warning-1"
        });
      }
    },
    deleteDiscount(index) {
      this.localDiscounts.splice(index, 1);
    },
    saveDiscount() {
      if (!this.$v.localDiscounts.$invalid) {
        if (!this.hasDuplicates(this.localDiscounts)) {
          this.$emit("change", this.$v.localDiscounts.$model);
        } else {
          this.$notify({
            type: "warning",
            title: "Duplicate!",
            message: "There is one more duplicate item",
            icon: "flaticon-warning-1"
          });
        }
      } else {
        this.$v.localDiscounts.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    closeDiscountModal() {
      this.showDiscountModal = false;
      this.$emit("close", false);
    },
    async hideModalFromButtonClose() {
      this.showDiscountModal = true;
      await this.detectChanges();
    },
    async hideModalFromButtonCancel() {
      await this.detectChanges();
    },
    async detectChanges() {
      let isEqual = lodash.isEqual(
        this.localDiscounts,
        this.copyLocalDiscounts
      );
      if (!isEqual) {
        let { value } = await Swal.fire({
          title: "Important",
          html:
            "The discount has been modified. <br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        });
        if (value) {
          this.saveDiscount();
        } else {
          this.localDiscounts = lodash.cloneDeep(this.copyLocalDiscounts);
          this.closeDiscountModal();
        }
      } else {
        this.closeDiscountModal();
      }
    },
    caculateTotal(item) {
      let totalAmount = (this.localGrossPrice * item.percent.$model) / 100;
      item.total.$model = parseFloat(totalAmount.toFixed(2));
    },
    hasDuplicates(discounts = []) {
      let descriptions = new Set();
      for (let discount of discounts) {
        if (descriptions.has(discount.description)) {
          return true;
        } else {
          descriptions.add(discount.description);
        }
      }
      return false;
    }
  },
  validations: {
    localDiscounts: {
      $each: {
        type: {
          required
        },
        description: {
          required,
          minLength: minLength(5),
          maxLength: maxLength(50)
        },
        percent: {
          required: requiredIf(value => {
            return "percentage" === value.type;
          }),
          minValueBasedOnType: withParams(
            { type: "minValueBasedOnType" },
            function(value, parentVm) {
              const type = parentVm.type;
              return type === "percentage" ? value >= 1 : value >= 0;
            }
          )
        },
        total: {
          required,
          minValue: minValue(0),
          customValidator: function(value, context) {
            return value > 0;
          }
        }
      }
    }
  }
};
</script>
